import { LitElement, html, css } from 'lit';
import { validationHandlerClear, validationHandler } from '../../utilities/formsUtilities';
import { close } from '../../utilities/icons';
import { accessibility, formStyles } from '../../utilities/styles';
export class AllInTextareaCounter extends LitElement {
    static properties = {
        required: { type: Boolean },
        maxlength: { type: String },
        name: { type: String },
        id: { type: String },
        rows: { type: String },
        label: { type: String },
        description: { type: String },
        labelalt: { type: String },
        count: { type: Number, state: true },
        value: { type: String },
        error_message: { type: String },
        placeholder: { type: String },
    };
    static get formAssociated() {
        return true;
    }
    get textarea() {
        return this.renderRoot.querySelector('textarea');
    }
    get counter() {
        return this.renderRoot.querySelector('.counter');
    }
    constructor() {
        super();
        this._internals = this.attachInternals();
    }
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        this._setCount();
        this._validateCount();
    }
    render() {
        let textarea = '';
        if (this.required) {
            textarea = html `<textarea data-label="${this.labelalt}" @input=${this._handleInput} @blur=${this._validateCount} id="${this.id}" name="${this.name}" rows=${this.rows} aria-required="true" maxlength="${this.maxlength}" placeholder="${this.placeholder ?? ''}" data-error_message=${this.error_message}>${this.value}</textarea>`;
        }
        else {
            textarea = html `<textarea data-label="${this.labelalt}" @input=${this._handleInput} @blur=${this._validateCount} id="${this.id}" name="${this.name}" rows=${this.rows} maxlength="${this.maxlength}" placeholder="${this.placeholder ?? ''}" data-error_message=${this.error_message}>${this.value}</textarea>`;
        }
        return html `\n        \n        <div class="textarea-counter">\n            <label for="${this.name}">${this.label}</label>\n            <p class="small">${this.description}</p>\n            <p class="small right">Characters left:\n                <span class="counter">${this.count}</span>\n            </p>\n            ${textarea}\n        </div>\n        `;
    }
    _handleInput(e) {
        validationHandlerClear(e.target);
        this._setCount();
        this._internals.setFormValue(e.target.value);
    }
    _setCount() {
        let count = this.textarea.value.length;
        let currentCount = this.maxlength - count;
        this.count = currentCount;
        if (currentCount < 0) {
            this.counter.classList.add('error');
        }
        else {
            this.counter.classList.remove('error');
        }
    }
    _validateCount() {
        this._setCount();
        let count = this.textarea.value.length;
        let currentCount = this.maxlength - count;
        if (currentCount < 0) {
            validationHandler(this.textarea, `You have exceeded the character limit`);
            this._internals.setValidity({ tooLong: true }, `You have exceeded the character limit for ${labelalt}`);
        }
        else {
            validationHandlerClear(this.textarea);
            this._internals.setValidity({ tooLong: false });
        }
    }
    checkValidity() {
        return this._internals.checkValidity();
    }
    reportValidity() {
        return this._internals.reportValidity();
    }
    get validity() {
        return this._internals.validity;
    }
    get validationMessage() {
        return this._internals.validationMessage;
    }
    static styles = [
        accessibility,
        formStyles,
        css `
            img[src=''],img[data-has_src='false']{
                display:none;
            }
            
        `
    ];
}
